import { Col, Row } from "antd";
import styled from "styled-components";

export const StyledRow = styled(Row)`
    .filter-container{
        width: 96%;

        [data-icon="close-circle"]{
            position: relative;
            right: 10px;
        }
    }
    &:not(:nth-of-type(1)){
        margin-top: 15px;
    }
`
export const DeleteCol = styled(Col)`
    a{
        text-align: center;
        width: 100%;
        display: block;
        position: relative;
        top: 4px;
        color: #cd0808;
        font-size: 17px;
    }
`;